import { InformationEquipmentListCard } from 'app/components/equipment';
import { formatInvitationToEquipmentListGrantedAccessI18nKey } from 'app/components/equipment/invitations/utils';
import { ReceivedInvitationsIcon } from 'app/components/icons';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Invitation } from 'services/api/invitations/types';

interface Props {
  className?: string;
  invitations: Invitation[];
}

export default function PendingReceivedInvitationsEquipmentListCard({
  className,
  invitations,
}: Props) {
  const { t } = useTranslation();

  const receivedInvitations = useMemo(() => {
    return [...invitations].sort((a, b) =>
      moment(b.accessDetails.invitedAt).diff(a.accessDetails.invitedAt),
    );
  }, [invitations]);

  const items = useMemo(
    () =>
      receivedInvitations.map(
        formatInvitationToEquipmentListGrantedAccessI18nKey,
      ),
    [receivedInvitations],
  );

  if (!items.length) {
    return null;
  }

  return (
    <InformationEquipmentListCard
      icon={ReceivedInvitationsIcon}
      title={t(
        'access_sharing.equipment_list.invitations.pending-received.title',
      )}
      items={items.slice(0, 2)}
      className={className}
      link={items.length >= 1 ? '/access/pending-invitations' : undefined}
      linkLabel={t(
        'access_sharing.equipment_list.invitations.pending-received.link',
      )}
    />
  );
}
